export const LOAN_PRODUCTS = [
  {
    key: "civil_servant_loan",
    title: "Civil Servant / SSB Loans",
    tagline: "Backed by your government salary",
    description:
      "Tailored for Zimbabwean government employees. Salary-deducted repayments. Fast approval at our lowest rates.",
    risk: "low",
    minAmount: 100,
    maxAmount: 10000,
    rateRange: "12% – 18% p.a.",
    termRange: "3 – 36 months",
    eligibility: [
      "Active SSB-registered government employee",
      "Valid EC / employee number",
      "Recent payslip",
      "National ID",
    ],
  },
  {
    key: "salary_based_loan",
    title: "Salary-Based Loans",
    tagline: "Your salary is your power",
    description:
      "For employees of registered private companies. Repayments structured around your pay cycle.",
    risk: "low",
    minAmount: 100,
    maxAmount: 8000,
    rateRange: "15% – 22% p.a.",
    termRange: "3 – 24 months",
    eligibility: [
      "12+ months continuous employment",
      "Recent 3 payslips",
      "Employer confirmation letter",
      "National ID",
    ],
  },
  {
    key: "business_loan",
    title: "Business Loans",
    tagline: "Fuel your hustle",
    description:
      "Working capital and growth financing for SMEs, sole traders and registered companies in Zimbabwe.",
    risk: "medium",
    minAmount: 500,
    maxAmount: 50000,
    rateRange: "20% – 32% p.a.",
    termRange: "3 – 24 months",
    eligibility: [
      "Registered business or trading license",
      "6+ months trading history",
      "Bank statements (3 months)",
      "Collateral may be required for larger sums",
    ],
  },
  {
    key: "agricultural_loan",
    title: "Agricultural Loans",
    tagline: "From seed to harvest",
    description:
      "Inputs, equipment and seasonal working capital for farmers. Flexible repayments aligned to harvest cycles.",
    risk: "medium",
    heroImage: "https://customer-assets.emergentagent.com/job_yambukai-finance/artifacts/0n3mwuir_Picture2.jpg",
    minAmount: 200,
    maxAmount: 20000,
    rateRange: "18% – 28% p.a.",
    termRange: "3 – 18 months",
    eligibility: [
      "Active farming operation",
      "Proof of land / lease",
      "Off-taker contract (preferred)",
    ],
  },
  {
    key: "asset_finance",
    title: "Asset Finance",
    tagline: "Drive what moves your dreams",
    description:
      "Acquire vehicles, equipment and machinery without paying the full price upfront. The asset secures the loan.",
    risk: "medium",
    minAmount: 1000,
    maxAmount: 80000,
    rateRange: "16% – 24% p.a.",
    termRange: "6 – 48 months",
    eligibility: [
      "Stable income or business cashflow",
      "Deposit (typically 20%+)",
      "Valid quotation for the asset",
    ],
  },
  {
    key: "school_fees_loan",
    title: "School & University Fees",
    tagline: "Invest in tomorrow",
    description:
      "Bridge the term so your child never misses school. Repay over multiple months.",
    risk: "low",
    minAmount: 100,
    maxAmount: 5000,
    rateRange: "14% – 20% p.a.",
    termRange: "3 – 12 months",
    eligibility: [
      "Active employment or business income",
      "Fee invoice from the institution",
      "National ID",
    ],
  },
];

export function getProduct(key) {
  return LOAN_PRODUCTS.find((p) => p.key === key);
}

export const STATUS_LABEL = {
  submitted: "Submitted",
  under_review: "Under Review",
  approved: "Approved",
  rejected: "Rejected",
  disbursed: "Disbursed",
};

export const STATUS_BADGE = {
  submitted: "bg-amber-100 text-amber-900 border-amber-300",
  under_review: "bg-blue-100 text-blue-900 border-blue-300",
  approved: "bg-emerald-100 text-emerald-900 border-emerald-300",
  rejected: "bg-rose-100 text-rose-900 border-rose-300",
  disbursed: "bg-violet-100 text-violet-900 border-violet-300",
};

export const RISK_BADGE = {
  low: "bg-emerald-100 text-emerald-900 border-emerald-300",
  medium: "bg-amber-100 text-amber-900 border-amber-300",
  high: "bg-rose-100 text-rose-900 border-rose-300",
};
